import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const cityDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/city`,
    );

    return response.data.map((item) => ({
      key: item.citId,
      text: item.citCity,
      value: item.citId,
    }));
  } catch (e) {
    console.error(e);
  }
};

// Assuming you have already imported gatewayInstance and SERVICE_ENDPOINT

export const cityDropdownFields = async (
  countryId,
  stateId,
  districtId = null,
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/dropdown`,
      {
        citCountry: countryId,
        citDistrict: districtId,
        citState: stateId, // Set to null by default or pass a value
      },
    );

    return response.data.map((item) => ({
      key: item.id,
      text: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const cityStartsWith = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/namestartswith`,
      search,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const cityByDistrictAndStartsWith = async ({ searchText, id }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/namestartswith/${id}`,
      searchText,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const cityByCountryAndStartsWith = async ({ searchText, id }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/namestartswith-and-country/${id}`,
      searchText,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const cityByStateAndStartsWith = async ({ searchText, id }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/namestartswith-and-state/${id}`,
      searchText,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const cityName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/name/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const findStateAndDistrictAgainstCity = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/cit-id/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const cityCreate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/create`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const geographicSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/geographic`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateCity = async (id, data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/update/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getByIdCity = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/get-by/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const createCitiesInBulk = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/city/create-bulk`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating cities in Bulk:", error);
    throw error;
  }
};
